import { Users, Zap, Sparkles, CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import DisplayCards from "@/components/ui/display-cards";

const WhySection = () => {
  const { t } = useLanguage();

  const displayCardsData = [
    {
      icon: <Users className="size-5" />,
      title: t("why.oneTeam"),
      description: t("why.oneTeamDesc"),
      date: "Core Value",
      iconClassName: "text-[hsl(var(--holographic-cyan))]",
      titleClassName: "text-[hsl(var(--holographic-cyan))]",
      className: "[grid-area:stack] hover:-translate-y-40 before:absolute before:w-[100%] before:outline-1 before:rounded-xl before:outline-border before:h-[100%] before:content-[''] before:bg-blend-overlay before:bg-background/50 grayscale-[100%] hover:before:opacity-0 before:transition-opacity before:duration-700 hover:grayscale-0 before:left-0 before:top-0",
    },
    {
      icon: <Zap className="size-5" />,
      title: t("why.endToEnd"),
      description: t("why.endToEndDesc"),
      date: "Full Service",
      iconClassName: "text-[hsl(var(--holographic-magenta))]",
      titleClassName: "text-[hsl(var(--holographic-magenta))]",
      className: "[grid-area:stack] translate-x-14 translate-y-10 hover:-translate-y-32 before:absolute before:w-[100%] before:outline-1 before:rounded-xl before:outline-border before:h-[100%] before:content-[''] before:bg-blend-overlay before:bg-background/50 grayscale-[100%] hover:before:opacity-0 before:transition-opacity before:duration-700 hover:grayscale-0 before:left-0 before:top-0",
    },
    {
      icon: <CheckCircle2 className="size-5" />,
      title: t("why.faster"),
      description: t("why.fasterDesc"),
      date: "Speed",
      iconClassName: "text-[hsl(var(--holographic-cyan))]",
      titleClassName: "text-[hsl(var(--holographic-cyan))]",
      className: "[grid-area:stack] translate-x-28 translate-y-20 hover:-translate-y-24 before:absolute before:w-[100%] before:outline-1 before:rounded-xl before:outline-border before:h-[100%] before:content-[''] before:bg-blend-overlay before:bg-background/50 grayscale-[100%] hover:before:opacity-0 before:transition-opacity before:duration-700 hover:grayscale-0 before:left-0 before:top-0",
    },
    {
      icon: <Sparkles className="size-5" />,
      title: t("why.vision"),
      description: t("why.visionDesc"),
      date: "Your Vision",
      iconClassName: "text-[hsl(var(--holographic-magenta))]",
      titleClassName: "text-holographic",
      className: "[grid-area:stack] translate-x-44 translate-y-32 hover:-translate-y-12",
    },
  ];

  return (
    <section id="why" className="py-16 md:py-24 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0 grid-pattern opacity-20" />
      
      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black mb-4 md:mb-6 text-glow-hover uppercase">
            {t("why.title")} <span className="text-holographic">{t("why.shape")}</span>?
          </h2>
          <p className="text-lg md:text-xl lg:text-2xl text-muted-foreground max-w-3xl mx-auto px-4">
            {t("why.subtitle")}
          </p>
        </div>

        {/* Display Cards - stacked interactive cards */}
        <div className="flex justify-center mb-16">
          <DisplayCards cards={displayCardsData} />
        </div>

        {/* Bottom CTA accent */}
        <div className="mt-32 text-center">
          <p className="text-lg md:text-xl text-muted-foreground px-8 py-4">
            {t("why.experience")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
